import { render } from "./grnhome.vue?vue&type=template&id=3ac92b78"
import script from "./grnhome.vue?vue&type=script&lang=js"
export * from "./grnhome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__